/* This code is the intellectual property of Bulb Inc. and other software publishers;
* it may not be altered, copied or disclosed without prior written approval.
* Copyright 2021, Bulb Inc. For more information, please email contact@hellobulb.com.
*          _
*  _            | | _
* | |         _ | || |
* | |__   _  | || || |__
* | '_ \ | | | || || '_ \
* | (_) || |_| || || (_) |
*  \___/  \___/ |_| \___/
*/

import { Pipe, PipeTransform } from '@angular/core';

/**
 * Custom pipe that converts cent currency to dollar.
 */
@Pipe({
  name: 'centToDollarConverter',
  standalone: false,
})
export class CentToDollarConverterPipe implements PipeTransform {
  /**
   * Transform the currency from cent to dollar.
   *
   * @param value  Current value in cent.
   * @param args Any additional arguments.
   */
  transform(value: number, ...args: any[]): any {
    return `$${(value / 100).toFixed(2)}`;
  }
}
